import axios from "axios";
import { Message } from "element-ui";
import store from "../store";
import qs from "qs";
const instance = axios.create({
  timeout: 6000000
});
const basicAuth = "Basic " + window.btoa("app:app");
const PbasicAuth = "Basic " + window.btoa("pig:pig");
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
const serialize = data => {
  const list = [];
  Object.keys(data).forEach(ele => {
    list.push(`${ele}=${data[ele]}`);
  });
  return list.join("&");
};

// 请求拦截器
instance.interceptors.request.use(
  function(config) {
    // console.log('发请求之前', config);
    if (config.url === "/api/oauth/token") {
      config.headers = {
        isToken: false,
        "TENANT-ID": "1",
        Authorization: config.method === "post" ? PbasicAuth : basicAuth
      };
      if (config.method === "post") {
        const cdata = config.data;
        config.headers["Content-type"] = "application/x-www-form-urlencoded";
        config.params = {
          code: cdata.code,
          grant_type: cdata.grant_type,
          randomStr: cdata.randomStr
        };
        config.data = serialize({
          username: cdata.username,
          password: cdata.password
        });
        config.headers["Content-type"] = "application/x-www-form-urlencoded";
        config.params = {
          code: cdata.code,
          grant_type: cdata.grant_type,
          randomStr: cdata.randomStr
        };
        // config.data = serialize({username: cdata.username, password: cdata.password});
        config.data = qs.stringify({
          username: cdata.username,
          password: cdata.password
        });
      }
    } else if (store.state.userInfo !== "") {
      let userToken = store.state.userInfo;
      config.headers["Authorization"] = "Bearer" + userToken.access_token; // token
    }
    if (
      config.url === "/api/sys-file/upload" ||
      config.url === "/api/sys-file/index/upload"
    ) {
      config.headers["Content-type"] = "multipart/form-data";
    }
    return config;
  },
  function(error) {
    // console.log('请求错误', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  res => {
    const status = Number(res.status) || 200;
    const message = res.data.msg;
    if (res.request.responseURL.indexOf("/api/mobile/check/") > 0) {
      return res;
    }
    if (status !== 200 || res.data.code === 1) {
      Message({
        message: message,
        type: "error"
      });
      return Promise.reject(new Error(message));
    }

    return res;
  },
  error => {
    if (error.response.status === 401) {
      Message({
        message: "登录超时，请重新登录",
        type: "error"
      });
      store.dispatch("loginOut");
      return;
    }
    // 处理 503 网络异常
    if (error.response.status === 503) {
      Message({
        message: error.response.data.msg,
        type: "error"
      });
    } else if (error.response.status !== 428 && error.response.status !== 426) {
      Message({
        message: `错误码：${error.response.data.msg}`,
        type: "error"
      });
    }

    return Promise.reject(error);
  }
);

// get请求
export function get(url, data = {}, config = {}) {
  return new Promise((resolve, reject) => {
    instance
      .get(url, {
        params: data,
        config
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// post请求
export function post(url, data = {}, config = {}) {
  return new Promise((resolve, reject) => {
    instance.post(url, data, config).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}
// put请求
export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    instance.put(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}
// delet请求
export function _delete(url, data = {}) {
  return new Promise((resolve, reject) => {
    instance.delete(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}



// WEBPACK FOOTER //
// ./src/api/axios.js